import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {FormGroup} from '@angular/forms/forms';
import {IDatepickerSchema, ToastService} from "maps-angular-components";
import {ModalConfirmComponent} from "src/app/shared/components/modal-confirm/modal-confirm.component";
import {HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, Validators} from "@angular/forms";
import {ProcessamentoService} from "src/app/processamento/processamento.service";

@Component({
  selector: 'app-processamento-periodo-modal',
  templateUrl: './processamento-periodo-modal.component.html',
  styleUrls: ['./processamento-periodo-modal.component.scss'],
})
export class ProcessamentoPeriodoModalComponent {

  form!: FormGroup;

  dataInicioProcessamento!: IDatepickerSchema;

  dataFimProcessamento!: IDatepickerSchema;

  isLoading = false;

  @Output() processamentoSuccess = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data,
    private readonly formBuilder: FormBuilder,
    private readonly processamentoService: ProcessamentoService,
    private readonly dialog: MatDialog,
    private readonly messageService: ToastService
  ) {
    this.form = this.formBuilder.group({
      dataInicio: ["", [Validators.required]],
      dataFim: ["", [Validators.required]],
    });

    this.dataInicioProcessamento = {
      formControlName: "dataInicio",
      formGroup: this.form,
      label: "Data início processamento",
      placeholder: "Selecione a data",
      panelClass: "small-input",
    };

    this.dataFimProcessamento = {
      formControlName: "dataFim",
      formGroup: this.form,
      label: "Data fim processamento",
      placeholder: "Selecione a data",
      panelClass: "small-input",
    };
  }

  get formValid() {
    const { dataInicio, dataFim } = this.form.value;
    return dataInicio != null && dataFim != null && dataInicio != "" && dataFim != "";
  }

  processarSelecionadas() {
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: "Confirmar processamento",
        message: `Deseja confirmar o processamento de todas as ${this.data.processamentosSelecionados.length} carteiras selecionadas?`,
        confirmText: "Confirmar",
        cancelText: "Cancelar",
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      dialogRef.close();

      if (!confirm) {
        return;
      }

      this.processamentoService
        .executarProcessamentoPeriodoSelecionadas(this.data.processamentosSelecionados.map((p) => p.carteiraId), this.form.value.dataInicio, this.form.value.dataFim)
        .subscribe(
          () => this.processamentoSuccess.emit(),
          (err: HttpErrorResponse) => this.messageService.erro(err.error.message),
          () => {},
        );
    });
  }

  processarTodas() {
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        title: "Confirmar processamento",
        message: `Deseja confirmar o processamento de todas as ${this.data.totalProcessamentos} carteiras filtradas?`,
        confirmText: "Confirmar",
        cancelText: "Cancelar",
      },
      width: "500px",
      maxHeight: "50vh",
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((confirm) => {
      dialogRef.close();

      if (!confirm) {
        return;
      }

      this.processamentoService
        .executarProcessamentoPeriodoTodas(this.data.filter, this.form.value.dataInicio, this.form.value.dataFim)
        .subscribe(
          () => this.processamentoSuccess.emit(),
          (err: HttpErrorResponse) => this.messageService.erro(err.error.message),
          () => {},
        );
    });
  }
}
